/**
 * Created by vaibhav on 31/3/18
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import Img from "gatsby-image";
import remark from 'remark';
import recommended from 'remark-preset-lint-recommended'
import remarkHtml from 'remark-html'
import { Carousel } from 'react-responsive-carousel';
import styles from 'react-responsive-carousel/lib/styles/carousel.min.css';
import './style.css';
import Fade from 'react-reveal/Fade'
import ConnectedProjectListAsync from './../ConnectedProjectListAsync';
/*import { FaInfoCircle } from 'react-icons/fa';*/


const breakpoint = {
    mobile: 727,
    ipadV: 768,
    ipadH: 1024,
    desktop:1200,
    large:1400
};
//we use this counter var to read the slide number outside the state
let currNdx = 0;
let prevNdx = 0;

export default class ImagesCarouselAsync extends Component {

  constructor(props) {
      super(props);
      this.loadSlides = this.loadSlides.bind(this);
      this.goToNextProj = this.goToNextProj.bind(this);
      this.goToProj = this.goToProj.bind(this);
      this.componentDidMount = this.componentDidMount.bind(this);
      this.showProjDes = this.showProjDes.bind(this);
      this.closeProjDes = this.closeProjDes.bind(this);
      this.updateCurrentSlide = this.updateCurrentSlide.bind(this);
      this._currNdx = this._currNdx.bind(this);
      this._statusNdx = this._statusNdx.bind(this);
      this.preloadImgs = this.preloadImgs.bind(this);
      this.onLoadImgs = this.onLoadImgs.bind(this);
      this.toggleProjGrid = this.toggleProjGrid.bind(this);
      this.toggleLegend = this.toggleLegend.bind(this);
      this.closeProjList = this.closeProjList.bind(this);

      this.state = {
        slides: null,
      currentCaption: '',
      _currentIndex: 0,
      slidesCount: null,
      opacity:0,
      projSlug: this.props.pf_id,
      projectGrid: false,
      showProjDes: 'hideProjDes',
      showLegend: false
      };

  }

  _statusNdx(index) {
    prevNdx= this.state.showProjDes;

    if (index !== this.state.slidesCount && index >= 0) { this._currNdx(index) } ;
    if(index === this.state.slidesCount -1){
      this.setState({
        projectGrid: true,
        //showLegend: false
      });
    }else{
      this.setState({
        projectGrid: false,
        //showLegend: false
      });
    }
    //console.log('index: '+ index +'/'+ this.state.slidesCount + '  - projectGrid: ' + this.state.projectGrid);
  }

  _currNdx(index) {
    currNdx = index;
    if(index !== this.state.slidesCount -1){
    this.props.history.replace(this.props.location.pathname + '#/' + this.state.projSlug + '/' + (index+1));
  }
  if(index === this.state.slidesCount -1){
  this.props.history.replace(this.props.location.pathname + '#/' + this.state.projSlug + '/' + this.state.slides.category.toLowerCase().replace(' ','-') );
}
     //console.log('currNdx: ' + currNdx);
  }

  updateCurrentSlide = (index) => {
        const { currentSlide } = this.state._currentIndex;

        if (currentSlide !== index) {
            this.setState({
                currentSlide: index
            });
        }
    }

    goToProj(proj) {
      this.setState({
         slides: null,
         _currentIndex: 0,
         opacity:0,
         projectGrid: false
       });
        this.loadSlides(proj, 0);
    }

  goToNextProj() {
    this.setState({
       slides: null,
       _currentIndex: 0,
       opacity:0
     });
      this.loadSlides(this.state.slides.nextProjSlug, 0);
  }

  loadSlides(pf_id, index) {
    var collection = 'portfolio';
    var _json = '/static/'+ collection + '-' + pf_id +'-'+this.props.lang+'.json';
    // // console.log(_json);

    axios.get(_json)
  .then(function (response) {

    currNdx = index;
    this.props.history.replace(this.props.location.pathname + '#/' + response.data.projSlug + '/' + (currNdx+1));
    // Push an empty slide to add the overview grid as last item of the carousel
    response.data.items.push('');
    // console.log(response.data);
  this.setState({
    showProjDes: 'hideProjDes',
    slides: response.data,
    slidesCount:response.data.items.length,
    opacity:1,
    loadedItems: [],
    imageLoadStatus: 'loading',
    projSlug: response.data.projSlug
  //  _currentIndex: currNdx
  });

  var prefix = this.props.screenWidth < breakpoint.mobile ? 'phone-' : '';
  this.preloadImgs(prefix);

  }.bind(this))
  .catch(function (error) {
     console.log(error);
  });

    }

    onLoadImgs(index) {
      if(this.state.loadedItems.length === this.state.slidesCount -1 ){
          this.setState({'imageLoadStatus': 'loaded'});
        //console.log('LOADED');
      }
      //console.log(this.state.loadedItems);
    this.setState(({ loadedItems }) => {
      return { loadedItems: loadedItems.concat(index) }
    })

  }


    preloadImgs(prefix) {
      if(this.state.slides != null){
        this.state.slides.items.map((p, index )=>
      {  var img = document.createElement('img');
        img.src = '/static/' + prefix + p.url; // Assigning the img src immediately requests the image
        //console.log(prefix + p.url); return img;
      }

      )
    }else{
      return;
    }
  }

  toggleProjGrid(){
  /*  if(this.state.showProjDes === 'showProjDes'){
      this.closeProjDes()
    }*/

    if(! this.state.projectGrid ){
    this.setState({projectGrid: true});
  }else{
    this.setState({projectGrid: false});
    if(currNdx === this.state.slidesCount -1){
      currNdx--;
    }
  }
}
closeProjList() {
  this.setState({projectGrid: false});
  currNdx--;
}

toggleLegend(){
  if(! this.state.showLegend ){
  this.setState({showLegend: true});
}else{
  this.setState({showLegend: false});
}
}

    showProjDes() {
      //console.log('this.state._currentIndex: ' + this.state._currentIndex);
      //this.state._currentIndex === 0 ? currNdx-- : currNdx;

      this.setState({
        showProjDes: 'showProjDes',
        _currentIndex: currNdx

      });
    }
    closeProjDes() {
      //console.log( 'currNdx:' + currNdx );
      prevNdx !== 'hideProjDes' ? currNdx : '';//++

      this.setState({
        showProjDes: 'hideProjDes',
        _currentIndex: currNdx
      });
    }


/*
  getImgData(index, size, title, subheadline, slug){

    return (
      <div key={"-" + index}>
      <Img style={{'display': 'block'}} alt={title} title={title} sizes={size}/>

          <div className="legend has-text-centered has-text-weight-light">
          {title} <br/>
          {subheadline}
          </div>

      </div>
    );
  }
*/
    componentDidMount() {
      //this.goToNextProj(0);
      this.loadSlides(this.props.pf_id, this.props.img_id);
    }

    render() {

      var _more = 'Read more';
      if(this.props.lang == 'de'){
        _more = 'Mehr';
      }
      if(this.props.lang == 'ru'){
        _more = 'Больше';
      }
      var screenWidth = this.props.screenWidth;
      var screenHeight = this.props.screenHeight;
      var orientation = screenWidth > (screenHeight+  200) ? 'H' : 'V'
      {/* console.log(screenWidth + ' ' + screenHeight + ' ' + orientation) */}


      if(screenWidth < breakpoint.mobile) {
        return (
          <div className={'content-status content-pre' + this.state.imageLoadStatus}>

          { this.state.slides !== null ?
            <div className="projTitlePhone">
            <h3 className="has-text-weight-bold" dangerouslySetInnerHTML={{ __html: this.state.slides.title }}/>
            <p dangerouslySetInnerHTML={{ __html: this.state.slides.location }}/>
            <p>{this.state.slides.category}</p>
            <p>&nbsp;</p>
            </div>
            :
            ''
          }

          {this.state.slides !== null ?
            this.state.slides.items.map((p, index )=>
            index < this.state.slidesCount - 1  ?
            <div className={
              'imgPortfolio is-' + (this.state.loadedItems.length >= index ? 'loaded' : 'loading')
            }
            key={"d-" + index}
            >
            <div className={
              'mobile-orient-' + orientation + ' ' +
              'sSlide images-' + this.state.imageLoadStatus +
              ' slide-' + this.state.loadedItems[index]
            } key={"p-" + index}>
            <img className="sSlideImg" src={'/static/phone-' + p.url}  alt={p.description} onLoad={this.onLoadImgs.bind(this, index)}/>
            </div>
            <div className="sLegend">
            { /* <span className="p">{p.description.replace(/#/g, "\n")}</span> */ }
            <span className="p" dangerouslySetInnerHTML={{ __html: p.description.replace(/#/g, "\n") }} />
            </div>
            </div>
            :
            ''
          ):
          ''
        }
        {this.state.slides !== null ?
          <div>
          <div className="projDesPhone" dangerouslySetInnerHTML={{ __html: remark().use(recommended).use(remarkHtml).processSync(this.state.slides.projDescription).toString()}}/>
          <div className="nxtPhone">
          <button type="button" className="nextProjBtnPhone" onClick={() => this.goToNextProj()}>
          <span className="nxtBtnPhone">
          <span className="nxtLabel">NEXT</span><br/>
            <span dangerouslySetInnerHTML={{ __html: this.state.slides.nextProjTitle }}/>
        </span>
        </button>
        </div>
        <div className={ 'grid-narrow projList-true' }>
         <ConnectedProjectListAsync goToProj={this.goToProj} lang={this.props.lang} projectCat={this.state.slides.category.toLowerCase().replace(' ','-')}/>
        </div>
        </div>
          :
          ''
        }
        </div>
        );
      } else {
        return (

          <div className={'overlayCarouselFrame content-status content-pre' + this.state.imageLoadStatus}
          style={{opacity:this.state.opacity}}
          >
          {this.state.slides !== null ?
            <Carousel
            className="overlaySlider"
            selectedItem={currNdx}
            showThumbs={false}
            showArrows={true}
            centerMode={false}
            //centerSlidePercentage={100}
            emulateTouch={true} //true
            swipeable={true}
            showStatus={false}
            autoPlay={false}
            stopOnHover={false}
            infiniteLoop={false}
            useKeyboardArrows={true}
            interval={5000}
            //transitionTime={800}
            showIndicators={false}
            showStatus
            onClick={(evt) => evt.stopPropagation()}
            //onClickItem={(i) => i === console.log('ccc: ' + i) }
            onChange={(i) => i === this.state.slidesCount ? this.goToNextProj(this.state.slides.nextProjSlug) : ''}
            onChange={(i) => this._statusNdx(i)}
            statusFormatter={
              (current, total) =>
              this.state.slides !== null ?
              <span>
              <span className="oTitle" dangerouslySetInnerHTML={{ __html: this.state.slides.title + ' - ' + this.state.slides.location  }} />
              <span className={"oProj oProj-"+this.state.projectGrid} onClick={this.toggleProjGrid}> { this.state.projectGrid ? this.state.slides.category + ' >' : '< ' + this.state.slides.category}</span>

          {/* <span className={"oDes oDes-" + this.state.showProjDes} onClick={this.state.showProjDes != 'showProjDes' ? this.showProjDes : this.closeProjDes}><button className="button btnShowProjDes ">{_more}</button></span> */}

          {/*    <span className={"showLegend showLegend-" +  this.state.showLegend} onClick={this.toggleLegend}><i className="fas fa-info-circle"></i></span> */}


              <button type="button" className={
                current === total - 1 && this.state.showProjDes !== 'showProjDes' ?
                'nextProj nextProjBtnVisible' : 'nextProj nextProjBtnHidden'
            } onClick={() => this.goToNextProj()}
            >
            </button>
            <button type="button"
            className={
              current === total - 1 && this.state.showProjDes !== 'showProjDes' ?
              'nxtBtn nxtBtnVisible' : 'nxtBtn nxtBtnHidden'
          }
            onClick={() => this.goToNextProj()}>
            <span className="nxtLabel">NEXT</span><br/>
            <span dangerouslySetInnerHTML={{ __html: this.state.slides.nextProjTitle }}/>
            </button>
            <span className="oCount">{current<= total-1 ? current + '/' + (total-1) : (current-1) + '/' + (total-1)} </span>
              </span>
              :
              ''
            }
            >
            {this.state.slides !== null ?
              this.state.slides.items.map((p, index )=>
              // loop through the items (except for the last key, that will be the grid of project)
               index < this.state.slidesCount - 1  ?
              <div className={
                'imgPortfolio is-' + (this.state.loadedItems.length >= index ? 'loaded' : 'loading')
              }
              key={"d-" + index}>
              <div className={
                'no-mobile-orient-' + orientation + ' ' +
                'oSlide images-' + this.state.imageLoadStatus +
                ' slide-' +
                this.state.loadedItems[index]
              }
                key={"p-" + index}>
              <img className={'oSlideImg oslideImg-' + p.format} src={'/static/' + p.url} onLoad={this.onLoadImgs.bind(this, index)} alt={p.description}/>
              </div>

              <div className={"legend oLegend legend-" + this.state.showLegend}>
              { /* <span className="p">{p.description.replace(/#/g, "\n")}</span> */ }
              <span className="p" dangerouslySetInnerHTML={{ __html: p.description.replace(/#/g, "\n") }} />
              </div>


              </div>

              :
              //last entry in array is an empty slide for the project grid
              ''

            )

            :
            ''
          }

            </Carousel>

            :
            ''
          }

            {this.state.slides ?

              <div className={ 'grid-large projList projList-' + this.state.projectGrid }>
              <ConnectedProjectListAsync closeProjList={this.closeProjList} goToProj={this.goToProj} _lang={this.props.lang} projectCat={this.state.slides.category.toLowerCase().replace(' ','-')}/>
              </div>

              :
              ''
            }

            {this.state.slides !== null ?
            <div id="projDescription"
            className={this.state.showProjDes}>

            <span className="closeProjDes" onClick={this.closeProjDes}><div class="_small gPlus has-text-centered"><span> X Close</span></div></span>
            <h3 className="has-text-weight-bold" dangerouslySetInnerHTML={{ __html: this.state.slides.title }} />
            <p dangerouslySetInnerHTML={{ __html: this.state.slides.location }} />
            <p className="catLink" onClick={this.toggleProjGrid}>{this.state.slides.category}</p>
            <p>&nbsp;</p>
            <p dangerouslySetInnerHTML={{ __html: remark().use(recommended).use(remarkHtml).processSync(this.state.slides.projDescription).toString()}}/>
            </div>
            :
            ''}
            {/* console.log(parseInt(this.state._currentIndex) + ' ' + (parseInt(this.state.slidesCount)-1)) */}
            </div>
        );



      }
<span className="p" dangerouslySetInnerHTML={{ __html: this.state.slides.title }} />

  }
}
  ImagesCarouselAsync.propTypes = {

  };



// WEBPACK FOOTER //
// ./src/components/ImagesCarouselAsync/index.js